import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';
import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, inject, signal } from '@angular/core';

import { StatusModel } from '@core/models/status.model';

interface DialogData {
  statuses: StatusModel[];
  projectName: string;
}

@Component({
  selector: 'app-status-select-dialog',
  templateUrl: './status-select-dialog.component.html',
  styleUrls: ['./status-select-dialog.component.less'],
  standalone: true,
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StatusSelectDialogComponent {
  private readonly dialogRef = inject(DialogRef);
  private readonly data = inject<DialogData>(DIALOG_DATA);

  private readonly state = signal<DialogData>({
    statuses: [],
    projectName: '',
  });

  readonly statuses = computed(() => this.state().statuses);
  readonly projectName = computed(() => this.state().projectName);

  constructor() {
    this.state.set(this.data);
  }

  onClose(): void {
    this.dialogRef.close();
  }

  onSelectStatus(status: StatusModel): void {
    this.dialogRef.close(status);
  }
}
